import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

const CapabilityCard = ({ title, description }) => {
  const initials = title
    .split(" ")
    .filter((word) => word.toLowerCase() !== "and")
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  return (
  <Card
    sx={{
      height: "100%",
      border: "1px solid var(--color-border)",
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(245,241,234,0.95))",
      transition: "transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "var(--shadow-soft)",
        borderColor: "rgba(183, 132, 69, 0.22)",
      },
    }}
  >
    <CardContent sx={{ p: { xs: 2.85, md: 3.3 } }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 3.5,
          background:
            "linear-gradient(135deg, rgba(183,132,69,0.16), rgba(183,132,69,0.06))",
          color: "primary.dark",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 800,
          fontSize: "0.96rem",
          mb: 2.3,
        }}
      >
        {initials}
      </Box>
      <Typography variant="overline" sx={{ color: "primary.main" }}>
        Capability
      </Typography>
      <Typography variant="h5" sx={{ mt: 1.05, mb: 1.25, maxWidth: "15ch" }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </CardContent>
  </Card>
  );
};

export default CapabilityCard;
